import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { HomeSliderRoutingModule } from './home-slider-routing.module';
import { HomeSliderListComponent } from './home-slider-list/home-slider-list.component';
import { HomeSliderCreateComponent } from './home-slider-create/home-slider-create.component';

@NgModule({
  declarations: [HomeSliderListComponent, HomeSliderCreateComponent],
  imports: [
    CommonModule,
    HomeSliderRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class HomeSliderModule { }
